<template>
  <div class="main">
    <div class="operation">
      <div class="btns">
        <el-button type="primary" size="mini" @click="enterAddGoods">新增商品</el-button>
        <el-button type="primary" size="mini">上架</el-button>
        <el-button type="primary" size="mini">下架</el-button>
        <el-button type="primary" size="mini">删除</el-button>
      </div>
      <div class="search">
        <div>
          <div class="demo-input-suffix">
            店铺名:
            <el-input v-model="input" class="searchInput" size="mini" placeholder="请输入店铺名"></el-input>
          </div>
          <div class="demo-input-suffix">
            内容:
            <el-input v-model="input" class="searchInput" size="mini" placeholder="请输入搜索内容"></el-input>
          </div>
          <el-button size="mini" type="primary">查询</el-button>
        </div>
      </div>
    </div>
    <div class="itemNav">
      <span>
        <el-checkbox v-model="allChecked" @change="allChenkedChange"></el-checkbox>
      </span>
      <span>序号</span>
      <span>商品缩略图</span>
      <span>商品标题</span>
      <span>关联店铺</span>
      <span>创建时间</span>
    </div>
    <div class="item" v-for="(item,index) in goodsList.page" :key="item.id">
      <span @click.stop="">
        <el-checkbox v-model="item.isFlag" @change="(e)=>singleChecked(e,item.id)"></el-checkbox>
      </span>
      <span>{{ index+1 }}</span>
      <span>
        <img
          :src="'https://api.onesb2c.com'+item.pic"
          alt
        />
      </span>
      <span>{{ item.goodsName }}</span>
      <span>{{ item.shopName }}</span>
      <span>{{ item.createTime }}</span>
    </div>
    <!-- 分页 -->
    <div class="pag">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="goodsList.total"
        :page-count="goodsList.pnum"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="size"
        @current-change="pageChange"
        @size-change="sizeChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { goodsBall } from "../../../service";
export default {
  data() {
    return {
      input: "",
      allChecked: false,
      goodsList:{},//商品列表
      allChecked:false,//全选
      pageNum: 1, //分页的当前页数，
      size: 20, //每页显示条数，默认显示100条每页
    };
  },
  created(){
    this.getGoodsBall();
  },
  methods: {
    enterAddGoods() {
      this.$router.push({
        path: "/addGoods"
      });
    },
    // 请求商品列表接口
    getGoodsBall(p=1) {
      let params = {
        p,
        size: this.size,
        // status: 1
      };
      goodsBall(params).then(res => {
        if( res.data.code === 0){
          this.goodsList = res.data.result;
        }else{
          this.$message.error(res.data.msg);
        }
      });
    },
    // 分页
    pageChange(p) {
      this.allChecked = false;
      this.pageNum = p;
      this.getGoodsBall(p);
    },
    // 分页的每页条数发生改变
    sizeChange(val) {
      this.size = val;
      this.getGoodsBall();
    },
    // 点击改变单选
    singleChecked(e, id) {
      let arr = JSON.parse(JSON.stringify(this.goodsList.page));
      arr.map((item, i) => {
        if (item.id === id) {
          this.$set(item, "isFlag", e);
        }
      });
      this.goodsList.page = JSON.parse(JSON.stringify(arr));
      this.singleChangeAll(e);
    },
    // 点击全选改变单选
    allChenkedChange(e) {
      let arr = JSON.parse(JSON.stringify(this.goodsList.page));
      arr.map((item, i) => {
        arr[i].isFlag = e;
      });
      this.goodsList.page = JSON.parse(JSON.stringify(arr));
    },
    // 单选改变全选
    singleChangeAll() {
      let arr = JSON.parse(JSON.stringify(this.goodsList.page));
      let flag = false;//false全选选中
      arr.map((el, i) => {
        if (el.isFlag === false) {
          flag = true;
        }
      });
      if (flag === false) {
        this.allChecked = true;
      } else {
        this.allChecked = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  padding: 0 20px;
  padding-right: 10px;
  border: none;
  box-sizing: border-box;
  .operation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
  .search {
    display: flex;
    align-items: center;
    > div:first-child {
      display: flex;
      align-items: center;
    }
    .searchInput {
      width: 180px;
      background: rgba(255, 255, 255, 1);
      border-radius: 3px;
      border-radius: 0;
      padding-left: 10px;
      margin-right: 20px;
    }
    .searchBtn {
      height: 38px;
      background: rgba(0, 119, 255, 1);
      border-radius: 0px 3px 3px 0px;
    }
  }
  .total {
    width: 121px;
    height: 12px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 12px;
    margin: 10px 0;
  }
  .itemNav,
  .item {
    padding-left: 18px;
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 16px;
    }
    span:nth-child(1) {
      width: 30px;
      display: inline-block;
      margin-right: 0;
    }
    span:nth-child(2) {
      display: inline-block;
      text-align: center;
      width: 6%;
    }
    span:nth-child(3) {
      display: inline-block;
      text-align: center;
      width: 14%;
    }
    span:nth-child(4) {
      display: inline-block;
      text-align: center;
      width: 30%;
    }
    span:nth-child(5) {
      display: inline-block;
      text-align: center;
      width: 24%;
    }
    span:nth-child(6) {
      display: inline-block;
      text-align: center;
      width: 20%;
    }
  }
  .itemNav {
    margin-bottom: 10px;
  }
  .item {
    background: rgba(246, 249, 252, 1);
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    height: 68px;
    padding: 0;
    padding-left: 18px;
    &:hover {
      background-color: #eee;
    }
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
    span:nth-child(3) {
      img {
        width: 50px;
        height: 50px;
      }
    }
    span:nth-child(4) {
      color: #333;
    }
    span:nth-child(5) {
      color: #333333;
    }
  }
  .pag {
    margin: 22px 0;
    text-align: center;
    /deep/ .btn-prev,
    /deep/ .btn-next {
      padding: 0 8px;
    }
  }
}
</style>